import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {EMPTY, of} from 'rxjs';
import { HardwareFaultCodeActionTypes, HardwareFaultCodeActions } from '../actions/hardware-fault-code.actions';
import {EventsService} from '../../../services/events.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as actions from '../../../store/actions';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {ERROR_CODE_Str} from '../../../shareModel';

@Injectable()
export class HardwareFaultCodeEffects {
  private actions$ = inject(Actions);
  private eventService = inject(EventsService);
  private store$ = inject(Store<fromStore.State>);
  private injector = inject(Injector);


  constructor() {}

  GetHardwareFaultCodesMaps$ = createEffect(() => this.actions$.pipe(
    ofType(HardwareFaultCodeActionTypes.GetHardwareFaultCodes),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.eventService.getHardwareFaultCodeMaps({otp: user.otp, dFlag: 1}).pipe(
        map((res: any) => {
          if (res.result && Array.isArray(res.msg.data)) {
            const mapped = res.msg.data.map((item) => ({
              ...item,
              Description: this.injector.get(TranslateService).instant(
                ERROR_CODE_Str + item.ErrorCode.padStart(2, 0),
                { Default: item.Description }
              ),
            }));
            return new actions.LoadHardwareFaultCodes(mapped);
          } else {
            return new actions.GetHardwareFaultCodesFails();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new actions.GetHardwareFaultCodesFails());
        })
      );
    })
  ));
  changeLanguageFaultCodeMaps$ = createEffect(() => this.actions$.pipe(
    ofType(HardwareFaultCodeActionTypes.ChangeLanguageFaultCodes),
    withLatestFrom(this.store$.select(fromStore.getHardwareFaultCodeMapsState)),
    switchMap(([action, data]) => {
      if (Object.keys(data.entities).length > 0) {
        const res = Object.values(data.entities).map((item: any) => ({
          ...item,
          Description: this.injector.get(TranslateService).instant(
            ERROR_CODE_Str + item.ErrorCode,
            { Default: item.Description }
          ),
        }));
        return of(new actions.LoadHardwareFaultCodes(res));
      } else {
        return of(new actions.GetHardwareFaultCodesFails());
      }
    }),
    // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
    catchError(error => {
      return of(new actions.GetHardwareFaultCodesFails());
    })
  ));



}
